// @internal
export function isNil(v) {
    return v === null || v === undefined;
}
